/**
 * Routes of docs/PORTAL-PLAN.md section 5.3. The paths come from WEB_ROUTES in the shared
 * contract so the server and the SPA cannot drift. Screens that need a session sit under
 * RequireSession (first GET /api/me decides); /a/:cid/* additionally under AccountLayout.
 */

import { Route, Routes } from 'react-router-dom';
import { WEB_ROUTES } from '@portal-contract';
import { Layout } from '@/screens/Layout';
import { RequireSession } from '@/screens/RequireSession';
import { AccountLayout } from '@/screens/AccountLayout';
import { LoginScreen } from '@/screens/LoginScreen';
import { LoginCodeScreen } from '@/screens/LoginCodeScreen';
import { AccountsScreen } from '@/screens/AccountsScreen';
import { OverviewScreen } from '@/screens/OverviewScreen';
import { InvoicesScreen } from '@/screens/InvoicesScreen';
import { InvoiceDetailScreen } from '@/screens/InvoiceDetailScreen';
import { PaymentsScreen } from '@/screens/PaymentsScreen';
import { StatementScreen } from '@/screens/StatementScreen';
import { SignedOutScreen } from '@/screens/SignedOutScreen';
import { SessionExpiredScreen } from '@/screens/SessionExpiredScreen';
import { UnavailableScreen } from '@/screens/UnavailableScreen';
import { NotFoundScreen } from '@/screens/NotFoundScreen';

export function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<LoginScreen />} />
        <Route path={WEB_ROUTES.login} element={<LoginScreen />} />
        <Route path={WEB_ROUTES.loginCode} element={<LoginCodeScreen />} />
        <Route element={<RequireSession />}>
          <Route path={WEB_ROUTES.accounts} element={<AccountsScreen />} />
          <Route element={<AccountLayout />}>
            <Route path={WEB_ROUTES.overview} element={<OverviewScreen />} />
            <Route path={WEB_ROUTES.invoices} element={<InvoicesScreen />} />
            <Route path={WEB_ROUTES.invoice} element={<InvoiceDetailScreen />} />
            <Route path={WEB_ROUTES.payments} element={<PaymentsScreen />} />
            <Route path={WEB_ROUTES.statement} element={<StatementScreen />} />
          </Route>
        </Route>
        <Route path={WEB_ROUTES.signedOut} element={<SignedOutScreen />} />
        <Route path={WEB_ROUTES.sessionExpired} element={<SessionExpiredScreen />} />
        <Route path={WEB_ROUTES.unavailable} element={<UnavailableScreen />} />
        <Route path="*" element={<NotFoundScreen />} />
      </Route>
    </Routes>
  );
}
